import { AgCellLocalStoreService, AgCellState } from '../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Injectable } from '@angular/core';

interface TypeCellState extends AgCellState {
}

@Injectable()
export class TypeCellLocalStoreService extends AgCellLocalStoreService<TypeCellState> {
  constructor() {
    super({
      cellValue: null,
      params: null,
    });
  }
}